import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/lib/locale/fr';
import en from 'vuetify/lib/locale/en';
import csqcOutils from '@/outils/CSQCOutils';

Vue.use(Vuetify);

export default new Vuetify({

  lang: {
    locales: { fr, en },
    current: csqcOutils.GetLangue(),
  },
  theme: {
    themes: {
      light: {
        primary: '#095797',
      },
      dark: {
        primary: '#095797',
      },
    },
  },
});
